import script from "./ApplicationPEL.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationPEL.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationPEL.vue?vue&type=style&index=0&id=7058e563&lang=css"
import "./ApplicationPEL.vue?vue&type=style&index=1&id=7058e563&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7058e563"]])

export default __exports__